import { format as formatTimeZone } from 'date-fns-tz';

const date = new Date();

interface ITimezone {
  id: number;
  location: string;
  name: string;
  timezoneOffset: string;
}

export const timezonesMap: Record<string, ITimezone> = {};

export const timezones: ITimezone[] = [
  {
    location: 'Midway Island',
    name: 'Pacific/Midway',
  },
  {
    location: 'Samoa',
    name: 'US/Samoa',
  },
  {
    location: 'Hawaii',
    name: 'US/Hawaii',
  },
  {
    location: 'Alaska',
    name: 'US/Alaska',
  },
  {
    location: 'Pacific Time (US & Canada)',
    name: 'US/Pacific',
  },
  {
    location: 'Tijuana',
    name: 'America/Tijuana',
  },
  {
    location: 'Arizona',
    name: 'US/Arizona',
  },
  {
    location: 'Mountain Time (US & Canada)',
    name: 'US/Mountain',
  },
  {
    location: 'Chihuahua',
    name: 'America/Chihuahua',
  },
  {
    location: 'Mazatlan',
    name: 'America/Mazatlan',
  },
  {
    location: 'Mexico City',
    name: 'America/Mexico_City',
  },
  {
    location: 'Monterrey',
    name: 'America/Monterrey',
  },
  {
    location: 'Saskatchewan',
    name: 'Canada/Saskatchewan',
  },
  {
    location: 'Central Time (US & Canada)',
    name: 'US/Central',
  },
  {
    location: 'Eastern Time (US & Canada)',
    name: 'US/Eastern',
  },
  {
    location: 'Indiana (East)',
    name: 'US/East-Indiana',
  },
  {
    location: 'Bogota',
    name: 'America/Bogota',
  },
  {
    location: 'Lima',
    name: 'America/Lima',
  },
  {
    location: 'Caracas',
    name: 'America/Caracas',
  },
  {
    location: 'Atlantic Time (Canada)',
    name: 'Canada/Atlantic',
  },
  {
    location: 'La Paz',
    name: 'America/La_Paz',
  },
  {
    location: 'Santiago',
    name: 'America/Santiago',
  },
  {
    location: 'Newfoundland',
    name: 'Canada/Newfoundland',
  },
  {
    location: 'Buenos Aires',
    name: 'America/Buenos_Aires',
  },
  {
    location: 'Stanley',
    name: 'Atlantic/Stanley',
  },
  {
    location: 'UTC',
    name: 'Etc/UTC',
  },
  {
    location: 'Azores',
    name: 'Atlantic/Azores',
  },
  {
    location: 'Cape Verde Is.',
    name: 'Atlantic/Cape_Verde',
  },
  {
    location: 'Casablanca',
    name: 'Africa/Casablanca',
  },
  {
    location: 'Dublin',
    name: 'Europe/Dublin',
  },
  {
    location: 'Lisbon',
    name: 'Europe/Lisbon',
  },
  {
    location: 'London',
    name: 'Europe/London',
  },
  {
    location: 'Monrovia',
    name: 'Africa/Monrovia',
  },
  {
    location: 'Amsterdam',
    name: 'Europe/Amsterdam',
  },
  {
    location: 'Belgrade',
    name: 'Europe/Belgrade',
  },
  {
    location: 'Berlin',
    name: 'Europe/Berlin',
  },
  {
    location: 'Bratislava',
    name: 'Europe/Bratislava',
  },
  {
    location: 'Brussels',
    name: 'Europe/Brussels',
  },
  {
    location: 'Budapest',
    name: 'Europe/Budapest',
  },
  {
    location: 'Copenhagen',
    name: 'Europe/Copenhagen',
  },
  {
    location: 'Ljubljana',
    name: 'Europe/Ljubljana',
  },
  {
    location: 'Madrid',
    name: 'Europe/Madrid',
  },
  {
    location: 'Paris',
    name: 'Europe/Paris',
  },
  {
    location: 'Prague',
    name: 'Europe/Prague',
  },
  {
    location: 'Rome',
    name: 'Europe/Rome',
  },
  {
    location: 'Sarajevo',
    name: 'Europe/Sarajevo',
  },
  {
    location: 'Skopje',
    name: 'Europe/Skopje',
  },
  {
    location: 'Stockholm',
    name: 'Europe/Stockholm',
  },
  {
    location: 'Vienna',
    name: 'Europe/Vienna',
  },
  {
    location: 'Warsaw',
    name: 'Europe/Warsaw',
  },
  {
    location: 'Zagreb',
    name: 'Europe/Zagreb',
  },
  {
    location: 'Athens',
    name: 'Europe/Athens',
  },
  {
    location: 'Bucharest',
    name: 'Europe/Bucharest',
  },
  {
    location: 'Cairo',
    name: 'Africa/Cairo',
  },
  {
    location: 'Harare',
    name: 'Africa/Harare',
  },
  {
    location: 'Helsinki',
    name: 'Europe/Helsinki',
  },
  {
    location: 'Istanbul',
    name: 'Europe/Istanbul',
  },
  {
    location: 'Jerusalem',
    name: 'Asia/Jerusalem',
  },
  {
    location: 'Kyiv',
    name: 'Europe/Kiev',
  },
  {
    location: 'Minsk',
    name: 'Europe/Minsk',
  },
  {
    location: 'Riga',
    name: 'Europe/Riga',
  },
  {
    location: 'Sofia',
    name: 'Europe/Sofia',
  },
  {
    location: 'Tallinn',
    name: 'Europe/Tallinn',
  },
  {
    location: 'Vilnius',
    name: 'Europe/Vilnius',
  },
  {
    location: 'Baghdad',
    name: 'Asia/Baghdad',
  },
  {
    location: 'Kuwait',
    name: 'Asia/Kuwait',
  },
  {
    location: 'Nairobi',
    name: 'Africa/Nairobi',
  },
  {
    location: 'Riyadh',
    name: 'Asia/Riyadh',
  },
  {
    location: 'Tehran',
    name: 'Asia/Tehran',
  },
  {
    location: 'Moscow',
    name: 'Europe/Moscow',
  },
  {
    location: 'Baku',
    name: 'Asia/Baku',
  },
  {
    location: 'Volgograd',
    name: 'Europe/Volgograd',
  },
  {
    location: 'Muscat',
    name: 'Asia/Muscat',
  },
  {
    location: 'Tbilisi',
    name: 'Asia/Tbilisi',
  },
  {
    location: 'Yerevan',
    name: 'Asia/Yerevan',
  },
  {
    location: 'Kabul',
    name: 'Asia/Kabul',
  },
  {
    location: 'Karachi',
    name: 'Asia/Karachi',
  },
  {
    location: 'Tashkent',
    name: 'Asia/Tashkent',
  },
  {
    location: 'Kolkata',
    name: 'Asia/Kolkata',
  },
  {
    location: 'Kathmandu',
    name: 'Asia/Kathmandu',
  },
  {
    location: 'Ekaterinburg',
    name: 'Asia/Yekaterinburg',
  },
  {
    location: 'Almaty',
    name: 'Asia/Almaty',
  },
  {
    location: 'Dhaka',
    name: 'Asia/Dhaka',
  },
  {
    location: 'Novosibirsk',
    name: 'Asia/Novosibirsk',
  },
  {
    location: 'Bangkok',
    name: 'Asia/Bangkok',
  },
  {
    location: 'Ho Chi Minh',
    name: 'Asia/Ho_Chi_Minh',
  },
  {
    location: 'Jakarta',
    name: 'Asia/Jakarta',
  },
  {
    location: 'Krasnoyarsk',
    name: 'Asia/Krasnoyarsk',
  },
  {
    location: 'Chongqing',
    name: 'Asia/Chongqing',
  },
  {
    location: 'Hong Kong',
    name: 'Asia/Hong_Kong',
  },
  {
    location: 'Kuala Lumpur',
    name: 'Asia/Kuala_Lumpur',
  },
  {
    location: 'Perth',
    name: 'Australia/Perth',
  },
  {
    location: 'Singapore',
    name: 'Asia/Singapore',
  },
  {
    location: 'Taipei',
    name: 'Asia/Taipei',
  },
  {
    location: 'Ulaan Bataar',
    name: 'Asia/Ulaanbaatar',
  },
  {
    location: 'Urumqi',
    name: 'Asia/Urumqi',
  },
  {
    location: 'Irkutsk',
    name: 'Asia/Irkutsk',
  },
  {
    location: 'Seoul',
    name: 'Asia/Seoul',
  },
  {
    location: 'Tokyo',
    name: 'Asia/Tokyo',
  },
  {
    location: 'Adelaide',
    name: 'Australia/Adelaide',
  },
  {
    location: 'Darwin',
    name: 'Australia/Darwin',
  },
  {
    location: 'Yakutsk',
    name: 'Asia/Yakutsk',
  },
  {
    location: 'Brisbane',
    name: 'Australia/Brisbane',
  },
  {
    location: 'Canberra',
    name: 'Australia/Canberra',
  },
  {
    location: 'Guam',
    name: 'Pacific/Guam',
  },
  {
    location: 'Hobart',
    name: 'Australia/Hobart',
  },
  {
    location: 'Melbourne',
    name: 'Australia/Melbourne',
  },
  {
    location: 'Port Moresby',
    name: 'Pacific/Port_Moresby',
  },
  {
    location: 'Sydney',
    name: 'Australia/Sydney',
  },
  {
    location: 'Vladivostok',
    name: 'Asia/Vladivostok',
  },
  {
    location: 'Magadan',
    name: 'Asia/Magadan',
  },
  {
    location: 'Auckland',
    name: 'Pacific/Auckland',
  },
  {
    location: 'Fiji',
    name: 'Pacific/Fiji',
  },
].map((item, index) => {
  const timezoneOffset = formatTimeZone(date, 'xxx', { timeZone: item.name });

  const timezone = {
    ...item,
    id: index + 1,
    location: `(GMT${timezoneOffset}) ${item.location}`,
    timezoneOffset,
  };

  if (!timezonesMap[timezoneOffset]) {
    timezonesMap[timezoneOffset] = timezone;
  }

  return timezone;
});

export const timezoneOptions = timezones.map((item) => ({
  label: item.location,
  value: item.name,
}));
